import "../assets/Text.css";
import { jsx as c } from "preact/jsx-runtime";
import { c as _ } from "./index.2w0W-O47.js";
const d = "_noMarginBottom_vbufd_45", s = {
  "step--2": "_step--2_vbufd_9",
  "step--1": "_step--1_vbufd_17",
  "step-0": "_step-0_vbufd_25",
  "step-1": "_step-1_vbufd_33",
  noMarginBottom: d
}, b = ({
  element: n = "p",
  text: a,
  fontStyle: t = "default",
  sizeStep: e = 0,
  removeMargin: l = !1,
  children: p,
  ...o
}) => {
  const u = n, r = () => {
    switch (t) {
      case "default":
        return [-2, -1, 0];
      case "prose":
        return [-2, -1, 0, 1];
      case "bold":
        return [-2, -1, 0, 1];
      default:
        return [];
    }
  };
  if (!r().includes(e))
    throw new Error(
      `pulse/Text: parameter sizeStep ${e} not allowed for fontStyle ${t}. Allowed sizes are ${r().join(
        ", "
      )}.`
    );
  return /* @__PURE__ */ c(
    u,
    {
      ...o,
      class: _([
        s.text,
        s[`step-${e}`],
        /* use kebab-case class names for easier access, although camelCase is preferred */
        `pulse-step-${e}`,
        `pulse-type-${t}`,
        l && s.noMarginBottom,
        o.class
      ]),
      children: p || a
    }
  );
};
export {
  b as T
};
